// Floating restart button - visible on all logged-in pages for demo tenants
import { useEnterpriseTour } from "./EnterpriseTourContext";
import { useAppConfig } from "../../appConfig";
import { TOUR_COMPLETED_KEY } from "./constants";

const TourRestartButton = () => {
  const appConfig = useAppConfig();
  const tour = useEnterpriseTour();

  const isDemoTenant = appConfig?.tenant?.demoMode && appConfig?.tenant?.demoTour;
  const tourCompleted = localStorage.getItem(TOUR_COMPLETED_KEY);

  // Only show when: demo tenant, tour is not active, and tour was previously completed/skipped
  if (!isDemoTenant || tour.isActive || !tourCompleted) return null;

  return (
    <button
      className="et-restart"
      onClick={() => tour.actions.startTour()}
      title="Restart demo tour"
    >
      <svg
        className="et-restart__icon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.65 2.35A7.958 7.958 0 008 0C3.58 0 .01 3.58.01 8S3.58 16 8 16c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 018 14 6 6 0 012 8a6 6 0 016-6c1.66 0 3.14.69 4.22 1.78L9 7h7V0l-2.35 2.35z"
          fill="currentColor"
        />
      </svg>
      Demo Tour
    </button>
  );
};

export default TourRestartButton;
